<ng-container *transloco="let t">
  <!-- Drawer Drop List -->
  @if (drawer$ | async; as drawer) {
    <div
      class="droplist-ctrl-container pointer-events-auto absolute hidden select-none overflow-hidden lg:block"
      [ngClass]="[drawer.state, drawer.medias.length > 0 ? 'full' : 'empty']">
      <div
        cdkDropList
        class="droplist-ctrl hidden flex-col px-3! pb-0! pt-1! lg:flex"
        data-testid="droplist"
        id="drawer-list"
        [cdkDropListData]="drawer.medias"
        [cdkDropListEnterPredicate]="isDropAllowed"
        [class.dragging]="drawer.isUserDragging"
        [ngClass]="[drawer.state, drawer.medias.length > 0 ? 'full' : 'empty']"
        (cdkDropListDropped)="drop($event)"
        (cdkDropListEntered)="isUserSorting = true"
        (cdkDropListExited)="isUserSorting = false">
        <!-- Image List -->
        @for (media of drawer.medias; track media.id; let idx = $index) {
          <div cdkDrag class="thumbnail group relative mx-0 my-1 cursor-grab first-of-type:mt-0">
            <pxc-sequence-media class="w-full" data-testid="media" [media]="media" />
            @if (!drawer.isUserDragging) {
              <button
                class="absolute! right-1! top-1! opacity-0 transition-opacity group-hover:opacity-100"
                size="xs"
                tuiButtonX
                type="button"
                [attr.data-testid]="'remove-media-' + idx"
                (click)="removeThumbnail(idx)"></button>
            }
            <div
              *cdkDragPlaceholder
              class="border-border-primary aspect-square w-full rounded-xl border-2 border-dashed bg-background-tertiary"></div>
          </div>
        }
      </div>
    </div>
    <!-- Drawer  -->
    <div
      class="drawer-container pointer-events-auto absolute hidden flex-col items-center rounded-xl border border-border-secondary bg-background-primary p-4 shadow-xl lg:flex"
      [class.dragging]="drawer.isUserDragging"
      [class.pb-2]="drawer.state !== DrawerState.TINY"
      [ngClass]="drawer.state">
      <!-- Handle -->
      <pxc-handle
        class="drawer-handle absolute z-1001 -translate-y-full rounded-full shadow-md"
        data-testid="handle"
        [class.dragging]="!drawer.isUserDragging && [DrawerState.TINY, DrawerState.COMPACT].includes(drawer.state)"
        (handleClicked)="updateDrawerState()" />
      <!-- Informations -->
      <div class="relative flex w-full flex-1 flex-col items-center gap-2">
        <div class="flex items-center justify-center gap-2">
          @if (drawer.medias.length > 0) {
            <p class="rounded-full bg-background-tertiary px-2 py-px" data-testid="media-count">
              {{ drawer.medias.length > 99 ? '99+' : drawer.medias.length }}
            </p>
          }
          <tui-icon
            class="z-1001"
            data-testid="tooltip-icon"
            tuiHintDirection="start"
            [tuiTooltip]="t('Le tiroir de comparaison vous permet de glisser vos photos puis de les comparer.')" />
        </div>
        @if (
          !isUserSorting && (drawer.state === DrawerState.OPEN || drawer.isUserDragging) && drawer.medias.length <= 0
        ) {
          <div
            class="empty-drawer-arrow my-auto flex w-full flex-col items-center justify-center gap-2 text-center"
            data-testid="expanded-title">
            <tui-icon icon="@tui.corner-right-down" />
            <p class="text-sm">{{ t('Glisser ici pour comparer.') }}</p>
          </div>
        }
        @if (drawer.state === DrawerState.TINY && !drawer.isUserDragging) {
          <p class="text-center text-xs text-text-tertiary" data-testid="tiny-title">
            {{ t('Comparez vos photos') }}
          </p>
        }
      </div>
      <!-- Bottom Buttons -->
      @if (drawer.medias.length > 0) {
        <div class="my-1 flex w-full flex-col items-stretch gap-1">
          <button
            appearance="secondary"
            data-testid="compare-button"
            size="s"
            tuiButton
            type="button"
            (click)="loadImageInGallery()">
            {{ t('Comparer') }}
          </button>
          <button
            appearance="outline-destructive"
            data-testid="clear-button"
            size="s"
            tuiButton
            type="button"
            (click)="clearItems()">
            {{ t('Vider') }}
          </button>
        </div>
      }
    </div>
  }
</ng-container>
